import "slick-carousel";
import $ from "jquery";
let addVoiceCount = 0; //暫定。max追加を判定するためのカウント
//読み込み後実行
$(() => {
  //スライダー
  $(".slickWrap").each(function () {
    const dotElem = $(this).find(".slickDots");

    $(this)
      .find(".slickContent")
      .slick({
        autoplay: false,
        infinite: true,
        arrows: false,
        fade: false,
        dots: false,
        centerMode: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        centerPadding: "0",
        focusOnSelect: false,
        touchMove: false,
        appendDots: dotElem,
        draggable: false,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              autoplay: true,
              dots: true,
              draggable: true,
              touchMove: true,
            },
          },
        ],
      });
  });

  //アコーディオン
  if ($(".question__title").length > 0) {
    $(".question__list").on("click", ".question__title", function () {
      const parent = $(this).parents(".question__listItem");
      parent.toggleClass("question__listItem--active");
      parent.find(".question__answer").slideToggle();
    });
    $(".question__title:first").trigger("click");
  }

  //sp サブメニュー
  $(".serviceSpMenu__headOpen,.serviceSpMenu__headClose").on("click", function () {
    $("body").toggleClass("serviceSpMenuOpen");
  });

  $(".serviceSpMenu__MenuListTitle--ac").on("click", function () {
    $(this).toggleClass("serviceSpMenu__MenuListTitle--open");
    $(".serviceSpMenu__subMenuWrap").slideToggle();
  });

  //メニュー詳細のアコーディオン
  if ($(".svContents__menuDetailhead").length > 0) {
    $(".svContents__menuDetailhead").on("click", function () {
      const parent = $(this).parents(".svContents__menuDetailListItem");
      parent.toggleClass("svContents__menuDetailListItem--open");
      parent.find(".svContents__menuDetailContents").slideToggle();
    });
    if (location.hash && $(location.hash).length > 0 && $(location.hash).is(".svContents__menuDetailListItem")) {
      //ページ内リンク付きの遷移の場合、最初ではなく該当箇所をオープンする
      $(location.hash).find(".svContents__menuDetailhead").trigger("click");
    } else {
      $(".svContents__menuDetailhead:first").trigger("click");
    }
  }

  //sp料金表の横スクロールアイコン
  if ($(".spScrollIcon").length > 0) {
    $(".spScrollIcon").each(function () {
      const parentElem = $(this).parents(".svContents__priceTableWrap");
      parentElem.on("scroll", function () {
        $(this).find(".spScrollIcon").addClass("spScrollIcon--none");
      });
    });
  }
});
